import { SimpleValueStat } from '~types/analyticsDashboard/SimpleValueStat';

export const MAX_TOP_ITEMS = 5;

export const colorValues = {
	primaryBlue: '#3790F4',
	accentDarkBlue: '#0567D5',
	accentGreen: '#5DC435',
	accentGrey: '#303651',
	accentOrange: '#FF9900',
	accentRed: '#DC562E',
	accentDarkRed: '#B20000',
	accentTurquoise: '#099FAA',
	accentDarkGreen: '#1D5B03',
	accentPurple: '#797EF6',
	accentMagenta: '#9423BC',
	accentPink: '#F600FA',
};

export const chartColors = [
	colorValues.primaryBlue,
	colorValues.accentGrey,
	colorValues.accentOrange,
	colorValues.accentRed,
	colorValues.accentGreen,
	colorValues.accentDarkBlue,
	colorValues.accentDarkRed,
	colorValues.accentTurquoise,
	colorValues.accentDarkGreen,
	colorValues.accentPurple,
	colorValues.accentMagenta,
	colorValues.accentPink,
];

export const REVENUE_SECTION_KEY = 'REVENUE';
export const ORDERS_SECTION_KEY = 'ORDERS';
export const CUSTOMERS_SECTION_KEY = 'CUSTOMERS';
export const VOLUME_SECTION_KEY = 'VOLUME';
export const PROMOTIONS_SECTION_KEY = 'PROMOTIONS';
export const PRODUCTS_SECTION_KEY = 'PRODUCTS';
export const CONNECT_SECTION_KEY = 'CONNECT';
export const BUSINESS_OVERVIEW_SECTION_KEY = 'BUSINESS_OVERVIEW';
export const PAYMENTS_SECTION_KEY = 'PAYMENTS';

export const WIDGETS_SESSION_STORAGE_KEY = 'analyticsWidgetSections';

export const REVENUE_SECTION_NAME = 'Full Service Sales';
export const ORDERS_SECTION_NAME = 'Orders';
export const CUSTOMERS_SECTION_NAME = 'Customers';
export const VOLUME_SECTION_NAME = 'Volume';
export const PROMOTIONS_SECTION_NAME = 'Promotions';
export const PRODUCTS_SECTION_NAME = 'Products/Services';
export const CONNECT_SECTION_NAME = 'Machines';
export const BUSINESS_OVERVIEW_SECTION_NAME = 'Business Overview';
export const PAYMENTS_SECTION_NAME = 'Payments';

export const allDashboardSections = [
	{
		functionName: 'updateBusinessOverviewSectionVisibility',
		name: BUSINESS_OVERVIEW_SECTION_NAME,
		key: BUSINESS_OVERVIEW_SECTION_KEY,
	},
	{
		functionName: 'updatePaymentsSectionVisibility',
		name: PAYMENTS_SECTION_NAME,
		key: PAYMENTS_SECTION_KEY,
	},
	{
		functionName: 'updateSalesSectionVisibility',
		name: REVENUE_SECTION_NAME,
		key: REVENUE_SECTION_KEY,
	},
	{
		functionName: 'updateOrderSectionVisibility',
		name: ORDERS_SECTION_NAME,
		key: ORDERS_SECTION_KEY,
	},
	{
		functionName: 'updateCustomerSectionVisibility',
		name: CUSTOMERS_SECTION_NAME,
		key: CUSTOMERS_SECTION_KEY,
	},
	{
		functionName: 'updateVolumeSectionVisibility',
		name: VOLUME_SECTION_NAME,
		key: VOLUME_SECTION_KEY,
	},
	{
		functionName: 'updatePromotionsSectionVisibility',
		name: PROMOTIONS_SECTION_NAME,
		key: PROMOTIONS_SECTION_KEY,
	},
	{
		functionName: 'updateProductsSectionVisibility',
		name: PRODUCTS_SECTION_NAME,
		key: PRODUCTS_SECTION_KEY,
	},
	{
		functionName: 'updateConnectSectionVisibility',
		name: CONNECT_SECTION_NAME,
		key: CONNECT_SECTION_KEY,
	},
];

export const availableSections = [
	BUSINESS_OVERVIEW_SECTION_KEY,
	PAYMENTS_SECTION_KEY,
	REVENUE_SECTION_KEY,
	ORDERS_SECTION_KEY,
	CUSTOMERS_SECTION_KEY,
	VOLUME_SECTION_KEY,
	PROMOTIONS_SECTION_KEY,
	PRODUCTS_SECTION_KEY,
	CONNECT_SECTION_KEY,
];

/**
 * [section key]: 'feature flag key'
 */
export const FEATURE_FLAGGED_SECTIONS = {
	[BUSINESS_OVERVIEW_SECTION_KEY]: 'dashboardBusinessOverview',
	[PAYMENTS_SECTION_KEY]: 'dashboardPayments',
};

export const MACHINE_TYPE_TABS = [
	{ label: 'All', value: 'all' },
	{ label: 'Washers', value: 'washers' },
	{ label: 'Dryers', value: 'dryers' },
];

export const centerTextLabelColor = '#aeb0b1';
export const centerTextValueColor = '#3790f4';

export const DEFAULT_SIMPLE_STATS_VALUE: SimpleValueStat = {
	value: 0,
	percentageChange: null,
};
